// @core/stores/activity/ActivityDecisionStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { activityApi } from '@core/api';
import type {
  ListDecisionsResponse,
  RecordDecisionRequest,
  RecordDecisionResponse,
} from '@core/types/activity';

class ActivityDecisionStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * List decisions
   */
  async ListDecisions(params?: { cursor?: string | number | boolean; direction?: string | number | boolean; limit?: string | number | boolean; object_id?: string | number | boolean; scope?: string | number | boolean; scope_id?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListDecisionsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.ListDecisions(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Record a decision
   */
  async RecordDecision(data: RecordDecisionRequest): Promise<RecordDecisionResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.RecordDecision(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const activityDecisionStore = new ActivityDecisionStore();
